import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewChild, ViewContainerRef } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Column } from 'src/app/ui/tables';


/**
 * @deprecated Use the table-headers component instead.  This one causes table layout issues in some cases due to the extra component elements anglar wraps the th elements in.
 */
@Component({
  selector: 'app-table-header',
  imports: [TableModule, NgClass],
  templateUrl: './table-header.component.html',
  styleUrl: './table-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableHeaderComponent {


  filterType: Record<Column<any>['type'], "numeric" | "text" | "date" | "boolean"> = {
    text: 'text',
    string: 'text',
    number: 'numeric',
    date: 'date',
    currency: 'numeric',
    boolean: 'boolean',
    chip: 'text',
    groupNameWithLink: 'text',
    groupArray: 'text',
    html: 'text',
    phone: 'text',
    percentage: 'numeric',
    partnerNameWithLink: 'text',
    logtype: 'numeric',
    link: 'text',
    tripIdWithLink: 'text',
    linkToPpm: 'text',
    groupIdWithLink: 'text',
    email: 'text',
    list: 'text',
    fraction: 'numeric',
    webcastWithUrl: 'boolean'
  }


  column = input.required<Column<any>>()


  @ViewChild('template', { static: true }) template: any;

  constructor(
    private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template)
  }

}
